import React from 'react';
import history from '../../history';
import config from 'config';
import Table from 'components/table';

export const changeStatus = status => {
  switch (status) {
    case 0:
      return <div style={{color: "#edbd2f", display: "inline-block"}}>На розгляді</div>
    case 1:
      return <div style={{color: "#008d4c", display: "inline-block"}}>Підтверджено</div>
    case 2:
      return <div style={{color: "#d73925", display: "inline-block"}}>Відхилено</div>
    default:
      return null
  }
}

export const changeType = type => {
  switch (type) {
    case "gratitude":
      return <div style={{color: "#008d4c", display: "inline-block"}}>Подяка</div>
    case "complaint":
      return <div style={{color: "#dd4b39", display: "inline-block"}}>Скарга</div>
    case "accost":
      return <div style={{color: "rgb(237, 189, 47)", display: "inline-block"}}>Звернення</div>
    default:
  }
}

export const InstitutionsAccostsList = ({ accosts }) => (
  <Table black hover>
    <thead>
      <tr>
        <th>Номер запису</th>
        <th>Лікарня</th>
        <th>Короткий опис</th>
        <th>Дата створення</th>
        <th>Тип</th>
        <th>Стан</th>
      </tr>
    </thead>
    <tbody>
      {accosts.map((accost, i) => (
        <tr key={accost.get('id')} onClick={() =>
          history.push({
            pathname: `/administration/staff-reviews/detail/${accost.get('id')}`,
            state: { name: 'Звернення'}
          })}>
          <td><span>Номер запису:</span>{accost.get('id')}</td>
          <td><span>Лікарня:</span>{accost.get('institution_data').get('full_title')}</td>
          <td><span>Короткий опис:</span>{accost.get('brief_description') }</td>
          <td><span>Дата створення: </span>{new Date(accost.get('date_created')).toLocaleString('uk-UA', config.options)}</td>
          <td><span>Тип:</span>{changeType(accost.get('type'))}</td>
          <td><span>Стан:</span>{changeStatus(accost.get('status'))}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)



// WEBPACK FOOTER //
// ./src/administration/reviews/institutions-accost-list.js